import React, { useState } from "react";
import { LEARNING_CATEGORIES } from "@/lib/learningContent";

export default function ResourcesLearning() {
  const [active, setActive] = useState(null);

  return (
    <div className="page" data-testid="page-resources-learning">
      <div className="page-header">
        <div>
          <div className="page-title">Learning Center</div>
          <div className="page-subtitle">Tutorials and how-tos for getting the most out of GovCo.AI</div>
        </div>
      </div>

      <div className="learn-grid">
        {LEARNING_CATEGORIES.map((cat) => (
          <div className="learn-cat" key={cat.title}>
            <h2 className="mkt-h3">{cat.title}</h2>
            <div className="learn-articles">
              {cat.articles.map((a) => (
                <button
                  type="button"
                  className="learn-article learn-article-playable"
                  key={a.title}
                  data-testid={`resources-learn-video-${a.video.replace(".mp4", "")}`}
                  onClick={() => setActive(a)}
                >
                  <span className="learn-article-title">{a.title}</span>
                  <span className="learn-article-meta">
                    <span>{a.read}</span>
                    <span className="pill-watch">▶ Watch</span>
                  </span>
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>

      {active && (
        <div
          className="learn-video-backdrop"
          data-testid="resources-learn-video-modal"
          onClick={() => setActive(null)}
        >
          <div className="learn-video-card" onClick={(e) => e.stopPropagation()}>
            <div className="learn-video-card-head">
              <span className="learn-video-card-title">{active.title}</span>
              <button
                type="button"
                className="learn-video-close"
                data-testid="resources-learn-video-close"
                onClick={() => setActive(null)}
                aria-label="Close video"
              >
                ✕
              </button>
            </div>
            <video
              key={active.video}
              src={`/videos/tutorials/${active.video}`}
              controls
              autoPlay
              className="learn-video-player"
            />
          </div>
        </div>
      )}
    </div>
  );
}
